import styled from '@emotion/styled'

export default styled.img`
  border-radius: 50%;
  height: 35px;
  object-fit: cover;
  width: 35px;
`
